import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Évaluez cet article',
    message: 'Vote exprimé',
    votes: votes => `${getEnglishPlurals(["avis", "avis"], +votes)},`,
    score: 'évaluation'
  },
  feedback: {
    label: 'Cet article vous a-t-il été utile ?'
  }
};
